import {
  PreloadAllModules,
  provideRouter,
  Routes,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import {
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TelegramService } from '@infrastructure/telegram';
import { environment } from '../../environment/environment';
import { authInterceptor, deviceFingerprintInterceptor, imageCacheInterceptor } from '@infrastructure/interceptors';
import { AuthApiService } from '@infrastructure/api/auth';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TabRouteReuseStrategy } from './router/tab-route-reuse.strategy';

export type CoreOptions = {
  routes: Routes;
};

export function provideCore({ routes }: CoreOptions): any[] {
  return [
    importProvidersFrom(FormsModule),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    { provide: RouteReuseStrategy, useClass: TabRouteReuseStrategy },
    provideHttpClient(withFetch(), withInterceptors([imageCacheInterceptor, deviceFingerprintInterceptor, authInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'ru',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideRouter(
      routes,
      withRouterConfig({}),
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withPreloading(PreloadAllModules)
    ),
    provideAppInitializer(() => {
      const telegram = inject(TelegramService);
      const auth = inject(AuthApiService);

      // alert('Initializing Telegram...');

      telegram.initialize();

      // alert('Telegram initialized');

      console.log('isProduction', environment.production, environment.INIT_DATA);
      console.log('Telegram initialized', telegram.initData);

      // return firstValueFrom(auth.authenticate({ init_data: telegram.initData || environment.INIT_DATA }))
      //   .then(response => {
      //     // alert('Authenticated successfully.');
      //   })
      //   .catch(error => {
      //     console.error('Auth error', error);
      //     // alert('Auth error');
      //   });
    }),
  ];
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/i18n/', '.json');
}
